// Generated by scripts/build-routes.mjs — do not edit by hand.
import type { BuiltinRouteData, BuiltinRouteDef } from './types';
import zugerseeTerrain from './zugersee.terrain.bin?url';
import chasseralTerrain from './chasseral.terrain.bin?url';

export const BUILTIN_ROUTES: BuiltinRouteDef[] = [
  {
    id: 'builtin-zugersee',
    name: 'Rund um den Zugersee',
    load: () => import('./zugersee.route.json').then((m) => m.default as BuiltinRouteData),
    terrainUrl: zugerseeTerrain,
  },
  {
    id: 'builtin-chasseral',
    name: 'Nods – Chasseral – Nods',
    load: () => import('./chasseral.route.json').then((m) => m.default as BuiltinRouteData),
    terrainUrl: chasseralTerrain,
  },
];
